import React from 'react';
import useOBDConnection from './live-data/useOBDConnection';
import {
  ConnectionSettingsPanel,
  LoggingControlsPanel,
  LiveGauges,
  DetailedDataPanels,
  DCANRequestExplorer,
} from './live-data/LiveDataComponents';

/**
 * LiveDataLogger — Orchestrates OBD connection, logging, and live gauges.
 * Split from original 910-line monolith into:
 *   - obd-pids.js (data constants)
 *   - useOBDConnection.js (connection/logging hook)
 *   - LiveDataComponents.jsx (UI components)
 */
const LiveDataLogger = () => {
  const obd = useOBDConnection();

  return (
    <div className="space-y-6">
      <ConnectionSettingsPanel obd={obd} />
      <LoggingControlsPanel
        isConnected={obd.isConnected}
        isLogging={obd.isLogging}
        logHistory={obd.logHistory}
        rawResponses={obd.rawResponses}
        startLogging={obd.startLogging}
        stopLogging={obd.stopLogging}
      />
      <LiveGauges liveData={obd.liveData} isLogging={obd.isLogging} />
      <DCANRequestExplorer obd={obd} />
      <DetailedDataPanels liveData={obd.liveData} />
    </div>
  );
};

export default LiveDataLogger;
